import { useMsal } from '@azure/msal-react';

import { apiScopes } from './msalConfig';

// Wspólny klient API (audyt E8/E9): jedno źródło pozyskiwania tokenu i wrappera
// fetch z odczytem `detail` z odpowiedzi błędu (lepsze komunikaty niż sam status).

export function useToken(): () => Promise<string> {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  return async () => {
    if (!account) {
      throw new Error('Not signed in');
    }
    const result = await instance.acquireTokenSilent({ scopes: apiScopes, account });
    return result.accessToken;
  };
}

export async function authFetch<T>(
  accessToken: string,
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...init.headers,
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!response.ok) {
    const detail = await response.text().catch(() => '');
    throw new Error(`${init.method ?? 'GET'} ${path} → ${response.status} ${detail}`);
  }
  if (response.status === 204) {
    return undefined as T;
  }
  return (await response.json()) as T;
}
